export default {
    props: {
        'prop' : String,
        'rules' : {
            type : Array,
            default: () => []
        },
        'label' : String,
        'error' : String,
        'value' : {}, 
        'required' :  {
            type: [Boolean, String],
            default : false
        },
        'disabled' :  {
            type: [Boolean, String],
            default : false
        },
      },
      data() {
        return {
          _value: "",
          id: null,
         
        };
      },
      computed: {
        isDirty(){
            return !!this.$data._value
        }
      },
      watch: {
        value(value) {
           this.setData();
        },
        error(val){
          if(!this.$refs['mdl']) return;
          setTimeout(()=>{
              if(this.$refs['mdl']){
                if(!!val) this.$refs['mdl'].$el.classList.add('is-invalid')
                else this.$refs['mdl'].$el.classList.remove('is-invalid')
              }
          },10)
        }
      },
      methods: {
        setData() {
            this.$set(this.$data, '_value', this.value)
            this.$nextTick(()=>this.$el.MaterialTextfield.checkDirty())
        },
        init() {
        }
      },
      mounted() {
        this.id = this._uid
        this.setData();
        this.init();
        
      },
      beforeDestroy(){
          componentHandler.downgradeElements(this.$el)
      }

}